import React from 'react'
import PropTypes from 'prop-types'
import { localize } from 'helpers/translator'
import Confirm from 'views/confirm/confirm'

const PaywallStorageConfirm = props => (
	<Confirm
		btTwo={localize('confirm_storage_paywall_button_text')}
		alertMessage={props.alertMessage}
		actionButtonType={0}
		actionTwo={props.upgradeSelected}
		closeAction={props.closeConfirmSelected}
	/>
)

PaywallStorageConfirm.propTypes = {
	alertMessage: PropTypes.string,
	upgradeSelected: PropTypes.func,
	closeConfirmSelected: PropTypes.func,
}

PaywallStorageConfirm.defaultProps = {
	alertMessage: '',
	upgradeSelected: () => {},
	closeConfirmSelected: () => {},
}

export default PaywallStorageConfirm
